const Product = require('../data/product')
const digitsOnly = require('digits-only')

function map(csvItem) {
	if(csvItem.SKU) {
		// a hormel food service product
		return {
			sku: digitsOnly(csvItem.SKU)
			, skuDescription: csvItem.SKU_DESC
		}
	}
	else {
		// an hhl product
		return {
			sku: digitsOnly(csvItem['SKU Number'])
			, skuDescription: csvItem['SKU Description']
		}
	}
}

module.exports = map